import logoPrefeitura from '@/ui/assets/logo-prefeitura.png';
import { TegLogo } from '@/ui/TegLogo';
import { ThemeToggle } from '@/ui/ThemeToggle';

import { PainelInstitucional } from './PainelInstitucional';

/**
 * Casca das tres telas de autenticacao: entrada, esqueci minha senha e volta da
 * redefinicao.
 *
 * Extraida porque sao tres repeticoes do mesmo arranjo — painel institucional a
 * esquerda, conteudo a direita, alternador de tema no canto, rodape com o
 * credito (CLAUDE.md, "Regras de interface", item 1).
 *
 * Em 375 px o painel sai de cena e sobra o conteudo, com o brasao e o nome do
 * sistema no topo. Sem rolagem horizontal em nenhuma largura.
 */
export function LayoutAutenticacao({
  titulo,
  descricao,
  children,
}: {
  titulo: string;
  descricao: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-dvh bg-background">
      <PainelInstitucional />

      <div className="relative flex flex-1 flex-col px-6 py-10">
        <div className="absolute right-4 top-4 z-10">
          <ThemeToggle />
        </div>

        <main id="conteudo" className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-104 space-y-8">
            <div className="flex flex-col items-center gap-4 lg:hidden">
              <img src={logoPrefeitura} alt="Prefeitura de São Paulo" className="h-12 w-auto" />
              <div className="flex items-center gap-2">
                <TegLogo size="sm" />
                <span className="text-lg font-bold tracking-tight">Sistema TEG</span>
              </div>
            </div>

            <header className="space-y-2">
              <h1 className="text-2xl font-bold tracking-tight">{titulo}</h1>
              <p className="text-sm text-muted-foreground">{descricao}</p>
            </header>

            {children}
          </div>
        </main>

        <p className="mx-auto w-full max-w-104 text-xs text-muted-foreground">
          © {new Date().getFullYear()} Prefeitura de São Paulo — Todos os direitos reservados
        </p>
      </div>
    </div>
  );
}
